// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { CREATE_SHIPMENT } from "../../graphql/mutations/shipments/shipments.mutations";

const useCreateShipment = () => {
  const [createShipmentMutation, { loading, error, data }] =
    useMutation(CREATE_SHIPMENT);

  const createShipment = async (shipment) => {
    try {
      const res = await createShipmentMutation({
        variables: {
          shipment: {
            ...shipment,
            customer_id: +shipment?.customer_id,
            contact_id: +shipment?.contact_id,
          },
        },
      });
      return res?.data?.createShipment;
    } catch (error) {
      console.error(`Error creating shipment: ${error?.message}`);
      alert(`Error creating shipment: ${error?.message}`);
    }
  };

  return { createShipment, loading, error };
};

export default useCreateShipment;
